/* eslint-disable jsx-a11y/heading-has-content */
import { HTMLAttributes } from 'react'
import { cn } from '@/utils/cn'

export default function CarFormLabel({
  className,
  ...props
}: HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h2
      className={cn(
        'text-heading-2xs text-tertiary uppercase mb-1 bg-fill-senary',
        className,
      )}
      {...props}
    />
  )
}
